import { Injectable } from '@angular/core';
import { HttpClient,  } from '@angular/common/http';
import { Observable,  } from 'rxjs';
import { map,  } from 'rxjs/operators';
// import { GetviewBO } from '../models/vieweligibility271.model';
// import { ErrorService } from 'src/app/services/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
import { Getview270BO } from '../pages/eligibility-logs/eligibility-logs-model';
import { ErrorService } from '../error.service';
// import { Getview271BO } from '../pages/eligibility270/eligibility270.model';
@Injectable({
  providedIn: 'root'
})
export class Eligibility271Service extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }
  public outputValues(state: Getview270BO): void {
    this.getList(state).subscribe(x => super.next(x));
  }
  getList(state?: Getview270BO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Claims/GetEligibilitySummaryList", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['edi271clientlist'],
            count: response['totalCount'],
            clients: response['idarray'],
            validclients: response['validClientIds']
          }
      ));
  }
}